import React from 'react'
import styled from 'styled-components'
import { Form, Field } from 'react-final-form'

import Modal from '../Modal'
import Button from '../../components/Button'
import { flexBoxStyles } from '../../components/Flexbox'

const NoteModal = ({ onClose, isOpen, note, onSubmit }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    closer={true}
    title={<H1>Notatki</H1>}
  >
    <Form initialValues={{ note: note }} onSubmit={onSubmit}>
      {({ handleSubmit }) => (
        <>
          <div style={{ width: '100%' }}>
            <label>
              Pole tekstowe
              <Field name="note" component={TextArea} type="textarea" />
            </label>
          </div>

          <Footer justify="space-between">
            <Button label="Zapisz" type="submit" onClick={handleSubmit} />
          </Footer>
        </>
      )}
    </Form>
  </Modal>
)

const H1 = styled.h1`
  font-weight: 400;
  margin-bottom: 1rem;
`

const TextArea = ({ input: { onChange, value }, ...rest }) => (
  <StyledArea
    value={value}
    onChange={(event) => onChange(event.target.value)}
    {...rest}
  />
)

const StyledArea = styled.textarea`
  margin-bottom: 50px;
  width: 400px;
  height: 200px;
  resize: vertical;
  border: inset 1px #ddd;
`

const Footer = styled.div`
  ${flexBoxStyles};
  &::before {
    position: absolute;
    left: 0;
    bottom: 7rem;
    content: '';
    border-bottom: 1px solid #eee;
    width: 100%;
  }
`

export default NoteModal
